import { useCallback, useContext } from 'react'

import { generatePath } from 'react-router-dom'

import { DeviceIdContext } from '../../providers'

export function useDeviceIdProvider() {
  const { deviceId, setDeviceId } = useContext(DeviceIdContext)

  const getRoute = useCallback(
    (path: string) => {
      return generatePath(path, { deviceId })
    },
    [deviceId]
  )

  return { deviceId, getRoute, setDeviceId }
}
